import ShareReportModal from './share-report-modal';

export default ShareReportModal;
